import { render } from "./ActionNotifications.vue?vue&type=template&id=5f4b2259&scoped=true"
import script from "./ActionNotifications.vue?vue&type=script&lang=js"
export * from "./ActionNotifications.vue?vue&type=script&lang=js"

import "./ActionNotifications.vue?vue&type=style&index=0&id=5f4b2259&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4b2259"]])

export default __exports__